import axios from 'axios'

const rq = {
  get (resource, params) {
    return axios.get(resource, {...params, ...{ headers: { Pragma: 'no-cache', 'Cache-Control': 'no-cache, no-store' } }})
  },

  post (resource, data) {
    return axios.post(resource, data)
  },

  put (resource, data) {
    return axios.put(resource, data)
  },

  delete (resource) {
    return axios.delete(resource)
  }
}

export default rq



// WEBPACK FOOTER //
// ./src/request.js